export default {"src":"/_next/static/media/UserManage.3803c8ab.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};